<script setup>
import WootLabel from 'dashboard/components-next/label/Label.vue';

import { useAutomationOperationsFormatters } from './composables/useAutomationOperationsFormatters';

defineProps({
  alerts: { type: Array, default: () => [] },
  status: { type: String, default: '' },
});

const { formatStatus, labelColor, observedThresholdLabel } =
  useAutomationOperationsFormatters();
</script>

<template>
  <div
    class="min-w-0 border-t border-n-weak pt-4 xl:border-l xl:border-t-0 xl:pl-5 xl:pt-0"
  >
    <div class="mb-2 flex items-center justify-between gap-3">
      <span class="text-heading-3 text-n-slate-12">
        {{ $t('AUTOMATION.OPERATIONS.HEALTH.ALERTS_TITLE') }}
      </span>
      <WootLabel
        :label="formatStatus(status)"
        :color="labelColor(status)"
        compact
      />
    </div>
    <div v-if="alerts.length" class="flex flex-col divide-y divide-n-weak">
      <div
        v-for="alert in alerts.slice(0, 6)"
        :key="alert.fingerprint"
        class="grid gap-1 py-3"
      >
        <div class="flex min-w-0 items-center justify-between gap-2">
          <span class="truncate text-body-main text-n-slate-12">
            {{ alert.key }}
          </span>
          <WootLabel
            :label="formatStatus(alert.severity)"
            :color="labelColor(alert.severity)"
            compact
          />
        </div>
        <div
          class="flex flex-wrap gap-x-3 gap-y-1 text-body-main text-n-slate-11"
        >
          <span>{{ alert.group }}</span>
          <span class="tabular-nums">
            {{ observedThresholdLabel(alert) }}
          </span>
          <span>{{ alert.runbook_key }}</span>
        </div>
      </div>
    </div>
    <div v-else class="py-8 text-center text-body-main text-n-slate-11">
      {{ $t('AUTOMATION.OPERATIONS.HEALTH.NO_ALERTS') }}
    </div>
  </div>
</template>
